import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { careContent } from "../../page-content/commercial-content/careContent";

const CareHomes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={careContent} />
      <Intro data={careContent} />
      <ContentLeft data={careContent} />
      <ContentRight data={careContent} />
      <CallToAction data={careContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default CareHomes;
